/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActorActivityRecordActorUserId } from './ActorActivityRecordActorUserId';
import {
    ActorActivityRecordActorUserIdFromJSON,
    ActorActivityRecordActorUserIdFromJSONTyped,
    ActorActivityRecordActorUserIdToJSON,
    ActorActivityRecordActorUserIdToJSONTyped,
} from './ActorActivityRecordActorUserId';
import type { StatementDisplayStatus } from './StatementDisplayStatus';
import {
    StatementDisplayStatusFromJSON,
    StatementDisplayStatusFromJSONTyped,
    StatementDisplayStatusToJSON,
    StatementDisplayStatusToJSONTyped,
} from './StatementDisplayStatus';
import type { StatementPeriod } from './StatementPeriod';
import {
    StatementPeriodFromJSON,
    StatementPeriodFromJSONTyped,
    StatementPeriodToJSON,
    StatementPeriodToJSONTyped,
} from './StatementPeriod';

/**
 * 
 * @export
 * @interface GetBalanceStatementByStudentRequest
 */
export interface GetBalanceStatementByStudentRequest {
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof GetBalanceStatementByStudentRequest
     */
    userId?: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof GetBalanceStatementByStudentRequest
     */
    studentId?: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {any}
     * @memberof GetBalanceStatementByStudentRequest
     */
    from?: any | null;
    /**
     * 
     * @type {any}
     * @memberof GetBalanceStatementByStudentRequest
     */
    to?: any | null;
    /**
     * 
     * @type {StatementDisplayStatus}
     * @memberof GetBalanceStatementByStudentRequest
     */
    displayStatus?: StatementDisplayStatus | null;
    /**
     * 
     * @type {string}
     * @memberof GetBalanceStatementByStudentRequest
     */
    descriptionSearch?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetBalanceStatementByStudentRequest
     */
    transactionCode?: string | null;
    /**
     * 
     * @type {StatementPeriod}
     * @memberof GetBalanceStatementByStudentRequest
     */
    period?: StatementPeriod | null;
}



/**
 * Check if a given object implements the GetBalanceStatementByStudentRequest interface.
 */
export function instanceOfGetBalanceStatementByStudentRequest(value: object): value is GetBalanceStatementByStudentRequest {
    return true;
}

export function GetBalanceStatementByStudentRequestFromJSON(json: any): GetBalanceStatementByStudentRequest {
    return GetBalanceStatementByStudentRequestFromJSONTyped(json, false);
}

export function GetBalanceStatementByStudentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetBalanceStatementByStudentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'] == null ? undefined : ActorActivityRecordActorUserIdFromJSON(json['userId']),
        'studentId': json['studentId'] == null ? undefined : ActorActivityRecordActorUserIdFromJSON(json['studentId']),
        'from': json['from'] == null ? undefined : json['from'],
        'to': json['to'] == null ? undefined : json['to'],
        'displayStatus': json['displayStatus'] == null ? undefined : StatementDisplayStatusFromJSON(json['displayStatus']),
        'descriptionSearch': json['descriptionSearch'] == null ? undefined : json['descriptionSearch'],
        'transactionCode': json['transactionCode'] == null ? undefined : json['transactionCode'],
        'period': json['period'] == null ? undefined : StatementPeriodFromJSON(json['period']),
    };
}

export function GetBalanceStatementByStudentRequestToJSON(json: any): GetBalanceStatementByStudentRequest {
    return GetBalanceStatementByStudentRequestToJSONTyped(json, false);
}

export function GetBalanceStatementByStudentRequestToJSONTyped(value?: GetBalanceStatementByStudentRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': ActorActivityRecordActorUserIdToJSON(value['userId']),
        'studentId': ActorActivityRecordActorUserIdToJSON(value['studentId']),
        'from': value['from'],
        'to': value['to'],
        'displayStatus': StatementDisplayStatusToJSON(value['displayStatus']),
        'descriptionSearch': value['descriptionSearch'],
        'transactionCode': value['transactionCode'],
        'period': StatementPeriodToJSON(value['period']),
    };
}

